<template>
  <el-row>
    <div class="dialog-masker" v-if="isDialog">
      <div class="dialog">
        <el-row type="flex" justify="space-between" class="dialog-header_title">
          <el-col class="fontBold">{{title}}</el-col>
          <el-col :span="1" class="text-right flex-center_end">
            <img src="../assets/img/close.png" alt="" @click="colse"/>
          </el-col>
        </el-row>
        <div class="dialog-header_content">
          <slot></slot>
        </div>
        <!-- <div class="dialog-header_content">
          <el-row>
            <el-col :span="11">
              <div class="flex border-line">
                <img src="../assets/img/icon/i-name.png" alt="" />
                <span>姓 名</span>
                <input type="text" placeholder="請輸入您的姓名" class="tel" />
              </div>
              <div class="flex border-line">
                <img src="../assets/img/icon/i-iPhone.png" alt="" />
                <span>电 话</span>
                <input type="text" placeholder="請輸入聯絡電話" class="tel" />
              </div>
              <div class="flex border-line">
                <img src="../assets/img/icon/i-emai.png" alt="" />
                <span>電 郵</span>
                <input type="text" placeholder="請輸入電郵地址" class="tel" />
              </div>
            </el-col>
            <el-col :span="12" :offset="1">
              <el-input type="textarea" :rows="10" placeholder="請輸入您留言的內容">
              </el-input>
            </el-col>
          </el-row>
          <div class="btn">
            <div class="btn-login">保存提交</div>
          </div>
        </div> -->
      </div>
    </div>
  </el-row>
</template>

<script>
  export default {
    data(){
      return{
        isDialog:true
      }
    },
    props:{
      title: {
        type: String,
        // default: "在线留言",
        default: "微信在线客服"
      },
    },
    methods:{
      colse(){
        this.isDialog=false
        this.$emit("colse")
      }
    }
  };
</script>

<style scoped>
  .btn {
    padding-top: 0.4rem;
    padding-bottom: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-login {
    width: 1.8rem;
    height: 0.56rem;
    background-color: #fe5b85;
    border-radius: 0.15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.25rem;
    color: #ffffff;
  }

  .border-line {
    padding-top: 0.3rem;
    padding-bottom: 0.1rem;
    font-size: 0.14rem;
    color: #333333;
    border-bottom: 0.02rem solid #f1f1f6;
  }

  .border-line span {
    padding-left: 0.13rem;
    padding-right: 0.26rem;
    font-size: 0.14rem;
    color: #333333;
  }

  .border-line input {
    font-size: 0.14rem;
    color: #a5afbb;
  }

  .dialog-masker {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }

  .dialog {
    width: 8rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .dialog-header_content {
    background-color: #ffffff;
    padding: 0.14rem 0.2rem;
    border-radius: 0 0 0.1rem 0.1rem;
  }

  .dialog-header_title {
    font-size: 0.22rem;
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    /* border-radius: 0.1rem; */
    letter-spacing: 0rem;
    color: #414042;
    padding: 0.14rem 0.2rem;
    border-radius: 0.1rem 0.1rem 0 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/dialog.vue